<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M10 .128c5.452 0 9.872 4.42 9.872 9.872s-4.42 9.872-9.872 9.872S.128 15.452.128 10 4.548.128 10 .128zm0 1.795C5.54 1.923 1.923 5.54 1.923 10c0 4.46 3.616 8.077 8.077 8.077 4.46 0 8.077-3.616 8.077-8.077 0-4.46-3.616-8.077-8.077-8.077zm0 3.59c.458 0 .835.342.89.785l.007.112v2.692h2.693c.457 0 .835.343.89.785l.007.113c0 .496-.402.897-.897.897h-2.693v2.693c0 .495-.401.897-.897.897-.458 0-.835-.342-.89-.785l-.007-.112v-2.693H6.41c-.457 0-.835-.342-.89-.784L5.513 10c0-.496.402-.897.897-.897h2.692V6.41c0-.495.402-.897.898-.897z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-add",
  components: {},
})
export class IconAdd extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconAdd;
</script>
